import React from 'react'
import styles from './styles.module.scss'
import BaseLoading from '@/src/components/helpers/base-loading/base-loading'
import CreateElements from '@/src/components/helpers/create-elements/create-elements'

export default function LoadingProduct() {
    return (
        <BaseLoading>
            <div className={styles.container}>
                <aside className={styles.image} />
                <div className={styles.infos}>
                    <aside className={styles.name} />
                    <aside className={styles.description} />
                </div>
                <div className={styles.items}>
                    <aside className={styles.title} />
                    <CreateElements quantity={5}>
                        <div className={styles.options}>
                            <aside className={styles.option} />
                            <aside className={styles.option} />
                        </div>
                    </CreateElements>
                </div>
            </div>
        </BaseLoading>
    )
}
